__turbopack_context__.v({
  "button": "contact-module__Cm4Wmq__button",
  "buttonStatic": "contact-module__Cm4Wmq__buttonStatic",
  "contactContainer": "contact-module__Cm4Wmq__contactContainer",
  "contactForm": "contact-module__Cm4Wmq__contactForm",
  "error": "contact-module__Cm4Wmq__error",
  "field": "contact-module__Cm4Wmq__field",
  "fieldError": "contact-module__Cm4Wmq__fieldError",
  "fieldLabel": "contact-module__Cm4Wmq__fieldLabel",
  "fieldNote": "contact-module__Cm4Wmq__fieldNote",
  "honeypot": "contact-module__Cm4Wmq__honeypot",
  "success": "contact-module__Cm4Wmq__success",
  "turnstileField": "contact-module__Cm4Wmq__turnstileField",
  "turnstileWidget": "contact-module__Cm4Wmq__turnstileWidget",
});
